import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { MtDriveFolder } from "server/models"
import { ASC, DESC, LIST, BLOCKS } from "const"
import { replaceHistoryState } from "client/utils"
import {
    StoreType,
    DriveSort,

    setDrivePath,
    setDriveListStyle,
    setDriveFolderList,
    setDriveFileList,

    setDriveSortColumn,
    setDriveSortOrder,
    createDriveUrl,
    createFolderName,
    clearDriveSelection,
} from "client/store"
import {
    Link,
    Bars,
    Blocks,
} from "client/components"
import {
    BreadCrumbWrapper,
    BreadCrumbList,
    BreadCrumbItem,
    BreadCrumbDelimiter,

    ListStyleWrapper,
    ListStyle,

    SortWrapper,
    SortDropdown,
    SortDropdownItem,
    SortReverse,
} from "./styled"

type DriveSortColumn = {
    key: DriveSort
    name: string
}

const BreadCrumbs = () => {
    const drivePath = useSelector((state: StoreType) => state.drive.drivePath)
    const baseRoute = useSelector((state: StoreType) => state.drive.baseRoute)
    const listStyle = useSelector((state: StoreType) => state.drive.listStyle)
    const onSelectFile = useSelector((state: StoreType) => state.drive.onSelectFile)
    const onSelectFiles = useSelector((state: StoreType) => state.drive.onSelectFiles)
    const onSelectVersion = useSelector((state: StoreType) => state.drive.onSelectVersion)
    const onSelect = onSelectFile || onSelectFiles || onSelectVersion

    const sortColumn = useSelector((state: StoreType) => state.drive.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.drive.sortOrder)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const openPath = (newDrivePath: MtDriveFolder[], href: string) => {
        dispatch(setDriveFolderList([]))
        dispatch(setDriveFileList([]))
        clearDriveSelection(dispatch)

        if (!onSelect) replaceHistoryState(href)
        dispatch(setDrivePath(newDrivePath))
    }

    const sortColumnList: DriveSortColumn[] = [
        { key: "updatedAt", name: lang.byDateChanged },
        { key: "id", name: lang.byId },
        { key: "name", name: lang.byName },
    ]
    let sortColumnName = ""
    sortColumnList.forEach((row) => {
        if (row.key === sortColumn) sortColumnName = row.name
    })

    return (
        <BreadCrumbWrapper>
            <BreadCrumbList>
                {
                    drivePath && drivePath.map((folder, index) => {
                        const newDrivePath = drivePath.slice(0, index + 1)
                        const href = createDriveUrl(newDrivePath, baseRoute)
                        const name = createFolderName(folder)
                        const key = `${name}_${folder.id}`
                        return (
                            <BreadCrumbItem key={key}>
                                {
                                    index > 0
                                    && <BreadCrumbDelimiter />
                                }
                                <Link
                                    href={onSelect ? "/#" : href}
                                    onClick={() => openPath(newDrivePath, href)}
                                >
                                    {name}
                                </Link>
                            </BreadCrumbItem>
                        )
                    })
                }
            </BreadCrumbList>

            <ListStyleWrapper>
                <ListStyle
                    left
                    active={listStyle === LIST}
                    title={lang.list}
                    onClick={() => dispatch(setDriveListStyle(LIST))}
                >
                    <Bars />
                </ListStyle>
                <ListStyle
                    right
                    active={listStyle === BLOCKS}
                    title={lang.blocks}
                    onClick={() => dispatch(setDriveListStyle(BLOCKS))}
                >
                    <Blocks />
                </ListStyle>
            </ListStyleWrapper>

            <SortWrapper>
                <SortDropdown title={sortColumnName}>
                    {
                        sortColumnList.map((row) => (
                            <SortDropdownItem
                                key={row.key}
                                onClick={() => dispatch(setDriveSortColumn(row.key))}
                            >
                                {row.name}
                            </SortDropdownItem>
                        ))
                    }
                    <SortDropdownItem
                        className="bordered"
                        onClick={() => {
                            if (sortOrder === ASC) dispatch(setDriveSortOrder(DESC))
                            if (sortOrder === DESC) dispatch(setDriveSortOrder(ASC))
                        }}
                    >
                        {lang.reverse}
                        {sortOrder === DESC && <SortReverse />}
                    </SortDropdownItem>
                </SortDropdown>
            </SortWrapper>
        </BreadCrumbWrapper>
    )
}
export default BreadCrumbs
